export const removeJSHref = (href: string): string => {
  if (!href || typeof href !== 'string') return '';
  // eslint-disable-next-line
  if (href.indexOf('javascript:') >= 0) return '';
  return href;
};
